export const Preachers = [
    "Pastor paul rika",
    "linda paul rika",
    "pastor cyril utomi",
    "pastor dauda garba"
]

export const MessageGenreListDefault = [
    { id: 1, genre: "Endtime Revival ministry" },
    { id: 2, genre: "Christian Maturity & Spiritual Growth" },
    { id: 3, genre: "Restitution" },
    { id: 4, genre: "Revelations & Endtime Events" },
    { id: 5, genre: "Spiritual Warfare" },
    { id: 6, genre: "Dressing & Adornment" },
    { id: 7, genre: "The Holy Woman" },
    { id: 8, genre: "God's wrath & judgement" },
    { id: 9, genre: "God's Love & kindness" },
    { id: 10, genre: "Christian Service & Evangelism" },
    { id: 11, genre: "Salvation" },
    { id: 12, genre: "Prayers" },
    { id: 13, genre: "Christian giving & Tithes" },
    { id: 14, genre: "Sanctification and holiness" },
    { id: 15, genre: "Church Traditions & Practices" },
    { id: 16, genre: "Heaven & Hell" }
];